﻿"use strict";

(function () {
  const qs = (selector, root = document) => root.querySelector(selector);
  const qsa = (selector, root = document) => Array.from(root.querySelectorAll(selector));

  const getPopupFromEventTarget = (target) => {
    if (!target) return null;
    if (target.classList?.contains("popup")) return target;
    return target.closest(".popup");
  };

  const parseNumber = (value, fallback = 0) => {
    const parsed = parseFloat(value);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const adpPopup = {
    sPrevious: window.scrollY,
    sDirection: "down",
    _eventsBound: false,

    init() {
      this.popupInit();
      this.events();
    },

    events() {
      if (this._eventsBound) return;
      this._eventsBound = true;

      document.addEventListener("click", (event) => {
        const closeBtn = event.target.closest(".popup-close");
        if (closeBtn) {
          this.closePopup(closeBtn);
        }

        const acceptBtn = event.target.closest(".popup-accept");
        if (acceptBtn) {
          this.acceptPopup(acceptBtn);
          this.closePopup(acceptBtn);
        }

        const ageClose = event.target.closest(".age-verification__popup-close");
        if (ageClose) {
          this.agePopup(ageClose);
          this.closePopup(ageClose);
        }

        const ageDeclined = event.target.closest(".age-verification__button-no");
        if (ageDeclined) {
          this.ageDeclined();
        }

        const overlay = event.target.closest(".popup-overlay");
        if (overlay) {
          qsa('.popup-open[data-overlay-close="true"]').forEach((popup) => {
            this.closePopup(popup);
          });
        }
      });

      document.addEventListener("keyup", (event) => {
        if (event.key === "Escape") {
          qsa('.popup-open[data-esc-close="true"]').forEach((popup) => {
            this.closePopup(popup);
          });
        }

        if (event.key === "F4") {
          qsa('.popup-open[data-f4-close="true"]').forEach((popup) => {
            this.closePopup(popup);
          });
        }
      });
    },

    popupInit() {
      if (!this._scrollDirectionBound) {
        this._scrollDirectionBound = true;
        document.addEventListener("scroll", () => {
          const scrollCurrent = window.scrollY;
          this.sDirection = scrollCurrent > this.sPrevious ? "down" : "up";
          this.sPrevious = scrollCurrent;
        });
      }

      qsa(".popup").forEach((popup) => {
        if (popup.dataset.openTrigger === "manual") {
          const selector = popup.dataset.openManualSelector;
          if (selector) {
            qsa(selector).forEach((trigger) => trigger.classList.add("popup-trigger"));

            if (!popup.dataset.manualBound) {
              popup.dataset.manualBound = "true";
              document.addEventListener("click", (event) => {
                const triggerEl = event.target.closest(selector);
                if (!triggerEl) return;

                event.preventDefault();
                popup.classList.remove("popup-already-opened");
                this.openPopup(popup);

                if (triggerEl.classList.contains("popup")) {
                  this.closePopup(triggerEl);
                }
              });
            }
          }
        }

        if (!this.isAllowPopup(popup) && !popup.classList.contains("age-verification")) {
          return;
        }

        if (!popup.dataset.triggerBound) {
          popup.dataset.triggerBound = "true";
          this.openTriggerPopup(popup);
        }
      });
    },

    openTriggerPopup(popup) {
      const trigger = popup.dataset.openTrigger;

      if (trigger === "none") {
        const ageVerification = this.getCookie(`popup-age-${popup.dataset.id || 0}`);
        if (!ageVerification) {
          this.openPopup(popup);
        }
      }

      if (trigger === "delay") {
        window.setTimeout(() => {
          this.openPopup(popup);
        }, parseNumber(popup.dataset.openDelayNumber) * 1000);
      }

      if (trigger === "exit" && !popup.dataset.exitBound) {
        popup.dataset.exitBound = "true";
        let showExit = true;
        document.addEventListener("mousemove", (event) => {
          const scroll = window.pageYOffset || document.documentElement.scrollTop;
          if (event.pageY - scroll < 7 && showExit) {
            this.openPopup(popup);
            showExit = false;
          }
        });
      }

      if (trigger === "scroll" && !popup.dataset.openScrollBound) {
        popup.dataset.openScrollBound = "true";
        const pointScrollType = popup.dataset.openScrollType;
        const pointScrollPosition = parseNumber(popup.dataset.openScrollPosition);

        document.addEventListener("scroll", () => {
          if (pointScrollType === "px") {
            if (window.scrollY >= pointScrollPosition) {
              this.openPopup(popup);
            }
          }

          if (pointScrollType === "%") {
            if (this.getScrollPercent() >= pointScrollPosition) {
              this.openPopup(popup);
            }
          }
        });
      }

      if (trigger === "accept") {
        const accept = this.getCookie(`popup-accept-${popup.dataset.id || 0}`);
        if (!accept) {
          this.openPopup(popup);
        }
      }
    },

    closeTriggerPopup(popup) {
      const trigger = popup.dataset.closeTrigger;

      if (trigger === "delay") {
        window.setTimeout(() => {
          this.closePopup(popup);
        }, parseNumber(popup.dataset.closeDelayNumber) * 1000);
      }

      if (trigger === "scroll" && !popup.dataset.closeScrollBound) {
        popup.dataset.closeScrollBound = "true";

        const pointScrollType = popup.dataset.closeScrollType;
        const pointScrollPosition = parseNumber(popup.dataset.closeScrollPosition);
        const initScrollPx = parseNumber(popup.dataset.initScrollPx);
        const initScrollPercent = parseNumber(popup.dataset.initScrollPercent);

        document.addEventListener("scroll", () => {
          if (pointScrollType === "px") {
            if (this.sDirection === "up" && window.scrollY < initScrollPx - pointScrollPosition) {
              this.closePopup(popup);
            }

            if (this.sDirection === "down" && window.scrollY >= initScrollPx + pointScrollPosition) {
              this.closePopup(popup);
            }
          }

          if (pointScrollType === "%") {
            if (this.sDirection === "up" && this.getScrollPercent() < initScrollPercent - pointScrollPosition) {
              this.closePopup(popup);
            }

            if (this.sDirection === "down" && this.getScrollPercent() >= initScrollPercent + pointScrollPosition) {
              this.closePopup(popup);
            }
          }
        });
      }
    },

    openPopup(target) {
      const popup = getPopupFromEventTarget(target);
      if (!popup) return;

      if (popup.classList.contains("popup-open")) return;
      if (popup.classList.contains("popup-already-opened")) return;

      if (popup.matches('[data-body-scroll-disable="true"]')) {
        const isMobileDisabled = popup.matches('[data-mobile-disable="true"]');
        const isMobile = window.matchMedia("(max-width: 767px)").matches;

        if (isMobile && isMobileDisabled) {
          document.body.classList.remove("popup-scroll-hidden");
        } else {
          document.body.classList.add("popup-scroll-hidden");
        }
      }

      const limit = parseInt(this.getCookie(`popup-${popup.dataset.id}`) || 0, 10) + 1;
      this.setCookie(`popup-${popup.dataset.id}`, limit, {
        expires: popup.dataset.limitLifetime,
      });

      popup.classList.add("popup-open");
      popup.dataset.initScrollPx = String(window.scrollY);
      popup.dataset.initScrollPercent = String(this.getScrollPercent());

      this.applyAnimation(popup, popup.dataset.openAnimation);
      this.closeTriggerPopup(popup);
    },

    agePopup(target) {
      const popup = getPopupFromEventTarget(target);
      if (!popup) return;

      this.setCookie(`popup-age-${popup.dataset.id}`, 1, {
        expires: 360,
      });
    },

    ageDeclined() {
      qsa(".age-verification__question").forEach((el) => el.classList.remove("show"));
      qsa(".age-verification__declined").forEach((el) => el.classList.add("show"));
    },

    acceptPopup(target) {
      const popup = getPopupFromEventTarget(target);
      if (!popup) return;

      this.setCookie(`popup-accept-${popup.dataset.id}`, 1, {
        expires: 360,
      });
    },

    closePopup(target) {
      const popup = getPopupFromEventTarget(target);
      if (!popup) return;

      this.applyAnimation(popup, popup.dataset.exitAnimation, () => {
        popup.classList.add("popup-already-opened");
        popup.classList.remove("popup-open");
      });

      document.body.classList.remove("popup-scroll-hidden");
    },

    isAllowPopup(popup) {
      const limitDisplay = parseInt(popup.dataset.limitDisplay || 0, 10);
      const limitDisplayCookie = parseInt(this.getCookie(`popup-${popup.dataset.id}`), 10);

      if (limitDisplay && limitDisplayCookie && limitDisplayCookie >= limitDisplay) {
        return false;
      }

      return true;
    },

    applyAnimation(target, name, callback) {
      const popup = getPopupFromEventTarget(target);
      if (!popup) return;

      const overlayName = typeof callback === "function" ? "popupExitFade" : "popupOpenFade";

      const overlay = popup.nextElementSibling;
      if (overlay && overlay.classList.contains("popup-overlay")) {
        overlay.classList.add("popup-animated", overlayName);
        overlay.addEventListener(
          "animationend",
          () => {
            overlay.classList.remove("popup-animated", overlayName);
          },
          { once: true }
        );
      }

      const wrap = qs(".popup-wrap", popup);
      if (wrap && name) {
        wrap.classList.add("popup-animated", name);
        wrap.addEventListener(
          "animationend",
          () => {
            wrap.classList.remove("popup-animated", name);
            if (typeof callback === "function") {
              callback();
            }
          },
          { once: true }
        );
      } else if (typeof callback === "function") {
        callback();
      }
    },

    getCookie(name) {
      const matches = document.cookie.match(
        new RegExp(`(?:^|; )${name.replace(/([.$?*|{}()\[\]\\/+^])/g, "\\$1")}=([^;]*)`)
      );
      return matches ? decodeURIComponent(matches[1]) : undefined;
    },

    setCookie(name, value, options = {}) {
      const opts = { ...options };
      opts.path = Object.prototype.hasOwnProperty.call(opts, "path") ? opts.path : "/";

      opts.expires = parseInt(opts.expires, 10);
      if (typeof opts.expires === "number" && opts.expires) {
        opts.expires = new Date().setDate(new Date().getDate() + opts.expires);
        opts.expires = new Date(opts.expires).toUTCString();
      }

      let updatedCookie = `${name}=${encodeURIComponent(value)}`;
      Object.keys(opts).forEach((propName) => {
        updatedCookie += `; ${propName}`;
        const propValue = opts[propName];
        if (propValue !== true) {
          updatedCookie += `=${propValue}`;
        }
      });

      document.cookie = updatedCookie;
    },

    getScrollPercent() {
      const h = document.documentElement;
      const b = document.body;
      const st = "scrollTop";
      const sh = "scrollHeight";
      return ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;
    },
  };

  const init = () => {
    adpPopup.init();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", init);
  document.addEventListener("shopify:section:unload", () => {
    document.body.classList.remove("popup-scroll-hidden");
  });
})();
